import { metrics, TheWestSection } from '@news-mono/component-library'
import { GetRouteAdTargeting, PageType } from '@news-mono/web-common'
import { layout } from '../../App.routing'
import { regionalSiteConfig } from './regional-site-config'

interface OurPapersRouteProps {
    section: TheWestSection
    getAdTargeting: GetRouteAdTargeting
}

export const getOurPapersRoute = ({
    section,
    getAdTargeting,
}: OurPapersRouteProps): PageType<TheWestSection> => ({
    kind: 'page',
    heading: 'Regional Publications',
    hideHeading: true,
    pageType: 'static',
    adTargeting: getAdTargeting('home', section, 'our-papers'),
    section,
    compositions: [
        layout.composition({
            type: 'box',
            props: {
                containerWidth: metrics.thewest.siteMetrics.mainContentWidth,
                horizontalGutters: 'outerMargin',
                verticalGutters: ['outerMargin', 'unset'],
            },
            contentAreas: {
                main: [
                    layout.component({
                        type: 'breadcrumb',
                        props: {
                            title: 'Regional Publications',
                            enableHeaderTag: true,
                        },
                    }),
                ],
            },
        }),
        layout.composition({
            type: 'zeus',
            props: {
                containerWidth: metrics.thewest.siteMetrics.mainContentWidth,
                horizontalGutters: true,
                hasBackgroundFill: true,
                stretchSelf: true,
            },
            contentAreas: {
                main: [
                    layout.nestedComposition({
                        type: 'box',
                        props: {
                            horizontalGutters: 'md',
                            verticalGutters: ['md', 'md'],
                            breakpoints: {
                                sm: {
                                    horizontalGutters: 'lg',
                                },
                                lg: {
                                    horizontalGutters: 'xl',
                                },
                            },
                        },
                        contentAreas: {
                            main: [
                                layout.component({
                                    type: 'our-publications',
                                    props: {},
                                }),
                            ],
                        },
                    }),
                ],
                sidebar: [
                    layout.component({
                        type: 'ad-unit',
                        props: {
                            noticePosition: 'below-center',
                            padding: [0, 0, metrics.thewest.margins.md, 0],
                            slot: {
                                id: 'sidebar-top',
                                size: 'desktopMrecHalfPage',
                                pageType: 'article',
                            },
                        },
                    }),
                    layout.component({
                        type: 'juliet',
                        props: {
                            cardType: {
                                type: 'landscape',
                                format: 'landscape-smallImage',
                            },
                            removeHorizontalGutters: true,
                            kickerMode: 'hidden',
                            contentIsTangential: true,
                            sectionHeader: {
                                heading: 'Local News',
                                section: 'generic',
                            },
                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: [
                                    section !== 'default'
                                        ? regionalSiteConfig[section]
                                              .mastheadTopic
                                        : 'news/wa',
                                ],
                                paging: {
                                    page: 1,
                                    pageSize: 3,
                                },
                            },
                        },
                    }),
                ],
            },
        }),
    ],
})
